/**
 * Validates whether a patient can receive an SMS.
 * Returns an array of error strings (empty = valid).
 */
export const validatePatientForSms = (patient) => {
  const errors = [];

  if (!patient?.mobilePhone || patient.mobilePhone.length < 6) {
    errors.push("Invalid mobile number, please fix the number");
  }

  if (patient?.died) {
    errors.push("Patient is DECEASED - you cannot send them a message");
  }

  return errors;
};
